import { useQueryClient } from 'react-query';
import { useAppSocket } from '../../../common/hooks';
import { ProxyServer } from '../entities';
import { ProxyServerAddressesGatewayKeys, ProxyServerHealthStatuses } from '../proxyServerAddresses.interfaces';
import { ProxyServersQueryKeys } from '../queries';

interface Data {
  addressId: string;
  proxyServerId: string;
  status: ProxyServerHealthStatuses;
  checkedAt: Date | null;
  errorMessage?: string;
}

interface Args {
  proxyServerId: string;
  isProxyServerRequestSuccess: boolean;
  queryClient: ReturnType<typeof useQueryClient>;
}

export const useUpdateProxyServerHealth = ({
  proxyServerId,
  isProxyServerRequestSuccess,
  queryClient
}: Args): void => {
  useAppSocket<Data>(ProxyServerAddressesGatewayKeys.UpdateHealthStatus, ({ lastMessage }) => {
    if (proxyServerId && isProxyServerRequestSuccess) {
      const { addressId, checkedAt, proxyServerId: serverId, status, errorMessage } = lastMessage;

      queryClient.setQueryData<ProxyServer>([ProxyServersQueryKeys.GetOneById, serverId], (data) => ({
        ...data,
        addresses: data?.addresses.map((address) =>
          address.id === addressId ? ({
            ...address,
            healthStatus: status,
            healthStatusError: errorMessage ?? null,
            healthStatusLastCheckedAt: checkedAt
          }) : address) ?? []
      }) as ProxyServer);
    }
  });
};
